import LendingScheduleSettings from "@/models/Products/ProductSettings/DefaultSettings/Schedule/LendingScheduleSettings";

export default class UpdateLendingScheduleSettingsRequest extends LendingScheduleSettings {
    updatedAt: Date;

    public constructor(settings: LendingScheduleSettings, updatedAt: Date) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
            this.dueDatesType = settings.dueDatesType;
            this.paymentIntervalPeriodType = settings.paymentIntervalPeriodType;
            this.paymentIntervalPeriodValue = settings.paymentIntervalPeriodValue;
            this.paymentIntervalPeriodValue = +this.paymentIntervalPeriodValue;
            this.fixedDaysOfMonth = settings.fixedDaysOfMonth;
            this.shortMonthHandlingType = settings.shortMonthHandlingType;
            this.numberOfInstallments = settings.numberOfInstallments;
            this.numberOfInstallments = +this.numberOfInstallments;
            this.numberOfInstallmentsMinimum = settings.numberOfInstallmentsMinimum;
            this.numberOfInstallmentsMinimum = +this.numberOfInstallmentsMinimum;
            this.numberOfInstallmentsMaximum = settings.numberOfInstallmentsMaximum;
            this.numberOfInstallmentsMaximum = +this.numberOfInstallmentsMaximum;
            this.firstDueDateOffsetPeriodType = settings.firstDueDateOffsetPeriodType;
            this.firstDueDateOffsetPeriodValue = settings.firstDueDateOffsetPeriodValue;
            this.firstDueDateOffsetPeriodValue = +this.firstDueDateOffsetPeriodValue;
            this.firstDueDateOffsetPeriodValueMinimum = settings.firstDueDateOffsetPeriodValueMinimum;
            this.firstDueDateOffsetPeriodValueMinimum = +this.firstDueDateOffsetPeriodValueMinimum;
            this.firstDueDateOffsetPeriodValueMaximum = settings.firstDueDateOffsetPeriodValueMaximum;
            this.firstDueDateOffsetPeriodValueMaximum = +this.firstDueDateOffsetPeriodValueMaximum;
            this.gracePeriodType = settings.gracePeriodType;
            this.gracePeriodValue = settings.gracePeriodValue;
            this.gracePeriodValue = +this.gracePeriodValue;
            this.nonWorkingDaysType = settings.nonWorkingDaysType;
            this.adjustPaymentDatesEnabled = settings.adjustPaymentDatesEnabled;
            this.adjustPrincipalPaymentScheduleEnabled = settings.adjustPrincipalPaymentScheduleEnabled;
            this.adjustInterestPaymentScheduleEnabled = settings.adjustInterestPaymentScheduleEnabled;
            this.adjustFeePaymentScheduleEnabled = settings.adjustFeePaymentScheduleEnabled;
            this.adjustPenaltyPaymentScheduleEnabled = settings.adjustPenaltyPaymentScheduleEnabled;
            this.paymentHolidaysEnabled = settings.paymentHolidaysEnabled;
        }
    }
}